const headers = {
  name: "Inventory requested",
  navigate: {
    tabs: [
      {
        name: "Requested",
        path: "/app/inventory/requested",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
